import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../../spacesPlatform/utils/actionParams';

export interface IPerformExtractEncryptionActionOnFlowDraftsRequestParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnFlowDraftsRequest extends Request<IPerformExtractEncryptionActionOnFlowDraftsRequestParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnFlowDrafts', {
      ids: ids,
      type: type
    });
  }
}
